import api from "./http";

// ===== ACADEMIC YEAR CONFIGURATION =====

export const getAcademicYears = async () => {
  try {
    const response = await api.get("/config/academic-years");
    return response.data;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      error.message ||
      "Failed to fetch academic years";
    throw new Error(errorMessage);
  }
};

export const getCurrentAcademicYear = async () => {
  try {
    const response = await api.get("/config/academic-years/current");
    return response.data;
  } catch (error) {
    console.error("Error fetching current academic year:", error);
    const errorMessage =
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      error.message ||
      "Failed to fetch current academic year";
    throw new Error(errorMessage);
  }
};

export const createAcademicYear = async (data) => {
  try {
    const response = await api.post("/config/academic-years", data);
    return response.data;
  } catch (error) {
    console.error("Error creating academic year:", error);
    const errorMessage =
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      error.message ||
      "Failed to create academic year";
    throw new Error(errorMessage);
  }
};

export const updateAcademicYear = async (id, data) => {
  try {
    const response = await api.put(`/config/academic-years/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating academic year:", error);
    const errorMessage =
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      error.message ||
      "Failed to update academic year";
    throw new Error(errorMessage);
  }
};

export const deleteAcademicYear = async (id) => {
  try {
    const response = await api.delete(`/config/academic-years/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting academic year:", error);
    const errorMessage =
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      error.message ||
      "Failed to delete academic year";
    throw new Error(errorMessage);
  }
};

// ===== DEPARTMENTS =====

export const getDepartments = async () => {
  try {
    const response = await api.get("/config/departments");
    return response.data;
  } catch (error) {
    console.error("Error fetching departments:", error);
    throw error;
  }
};

export const createDepartment = async (data) => {
  try {
    const response = await api.post("/config/departments", data);
    return response.data;
  } catch (error) {
    console.error("Error creating department:", error);
    throw error;
  }
};

export const updateDepartment = async (id, data) => {
  try {
    const response = await api.put(`/config/departments/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating department:", error);
    throw error;
  }
};

export const deleteDepartment = async (id) => {
  try {
    const response = await api.delete(`/config/departments/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting department:", error);
    throw error;
  }
};

// ===== FEE TYPES =====

export const getFeeTypes = async () => {
  try {
    const response = await api.get("/config/fee-types");
    return response.data;
  } catch (error) {
    console.error("Error fetching fee types:", error);
    throw error;
  }
};

export const createFeeType = async (data) => {
  try {
    const response = await api.post("/config/fee-types", data);
    return response.data;
  } catch (error) {
    console.error("Error creating fee type:", error);
    throw error;
  }
};

export const updateFeeType = async (id, data) => {
  try {
    const response = await api.put(`/config/fee-types/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating fee type:", error);
    throw error;
  }
};

export const deleteFeeType = async (id) => {
  try {
    const response = await api.delete(`/config/fee-types/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting fee type:", error);
    throw error;
  }
};

// ===== BANKS =====

export const getBanks = async (activeOnly = false) => {
  try {
    const response = await api.get("/config/banks", {
      params: activeOnly ? { activeOnly: "Y" } : undefined,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching banks:", error);
    throw error;
  }
};

// ===== SCHOOL PROFILE =====
export const getSchoolProfile = async () => {
  try {
    const response = await api.get("/config/school-profile");
    return response.data;
  } catch (error) {
    console.error("Error fetching school profile:", error);
    throw error;
  }
};
const configService = {
  getAcademicYears,
  getCurrentAcademicYear,
  createAcademicYear,
  updateAcademicYear,
  deleteAcademicYear,
  getDepartments,
  createDepartment,
  updateDepartment,
  deleteDepartment,
  getFeeTypes,
  createFeeType,
  updateFeeType,
  deleteFeeType,
  getBanks,
  getSchoolProfile,
};

export default configService;
